export const environment = {
  name: 'Development',
  production: false,
  isManualLoginAllowed: true,
  appVersion: '3.38.0-alpha.185411',
  appInsightsInstrumentationKey: "1100c6df-6751-4cc7-82ac-7fddd5d34285",
  isMockEnabled: true,
  apiUrl: 'https://cms-gw-dev.stealthmonitoring.net/',
  appThemeName: 'StealthHub',
  gtmContainerId: "GTM-MQJQPPC",
  gtmAuthKey: "8LehP1WFy1cvR-gD0zYDpA",
  gtmEnvironment: "env-37",
  tokenKey: "Abp.AuthToken",
  encryptedTokenKey: "enc_auth_token",
  tenantIdKey: "hub-tenantid",
  userIdKey: "hub-userid",
  lastStoredUsernameKey: "login_rememberMe",
  userManagement: {
    defaultAdminUserName: 'Admin'
  },
  appBaseUrl: "https://hub-dev.ecamapps.net",
  customerPortalUrl: "https://central-dev.ecam.com",
  azure: {
    clientId: "e38e3471-cc48-4c01-ad06-0394ceaba2de",
    authority: "https://login.microsoftonline.com/2fa83d3f-9212-4e3e-84bd-696e62e31766",
    redirectUrl: "https://hub-dev.ecamapps.net"
  },
  stsUrl: "https://stealth-sts-dev.stealthmonitoring.net/Auth/Exchange",
  smiUrl: "http://incidents-dev.stealthmonitoring.net",
  auditContainerName: "auditcamera",
  auditAccountName: "stgshhubauditdev",
  blobConnectionKey:"ixvyYFEAslfqRCYM/hsytRPOipXN1gG7TWwpThqXNSiYr5UeND2/ugJXeRoNvH24asP74EYWDsv7+AStwxLI6g==",
  salesforceUrl: 'https://ecam--fullsb.sandbox.lightning.force.com/lightning/r/Incident__c/',
  salesforceCaseUrl: 'https://ecam--fullsb.sandbox.lightning.force.com/lightning/r/Case',
  firebase: {
    apiKey: "AIzaSyATsJqB0whxqENPOKhywToaMbYsy9p772w",
    authDomain: "stealth-hub-development.firebaseapp.com",
    projectId: "stealth-hub-development",
    storageBucket: "stealth-hub-development.appspot.com",
    messagingSenderId: "961610525263",
    appId: "1:961610525263:web:437d728396316a39e1583a",
    measurementId: "G-H1H3EH3B4C"
  },
  elastic: {
    url: 'https://stealth-elasticcloud.es.southcentralus.azure.elastic-cloud.com:9243',
    user: "elastic",
    pass: "5u21igFCkAk3eBadpxbTF3JJ",
    debug: false,
  },
  okta: {
    clientId: '0oa25aoh9mo8pORD30h8'
  },
  logoUploaderBaseUrl: "https://stglogouploaderdev.blob.core.windows.net",
};
